import React, { useContext } from "react";
import { HRLocaleContext } from "../i18n/HRLocaleProvider";
import useHRCopy from "../i18n/useHRCopy";

const TONES = {
  // over the video hero (transparent nav)
  light: {
    active: "text-white",
    idle: "text-white/60 hover:text-white",
    sep: "text-white/30",
  },
  // on paper (solid nav, drawer, footer)
  dark: {
    active: "text-ink",
    idle: "text-steel/70 hover:text-ink",
    sep: "text-linestrong",
  },
  // on the black OnHuman.tech ground
  tech: {
    active: "text-white",
    idle: "text-white/60 hover:text-white",
    sep: "text-white/30",
  },
};

// One locale for both domains: the switch writes to the shared locale context,
// so the choice made on OnHuman HR carries over to OnHuman.tech and back.
// `className` sets the type treatment so each site can use its own family.
export default function LangSwitch({
  tone = "dark",
  className = "font-hanken text-[13px] font-semibold",
}) {
  const { locale, setLocale } = useContext(HRLocaleContext);
  const copy = useHRCopy();
  const isTR = locale === "tr";
  const t = TONES[tone] || TONES.dark;

  return (
    <div role="group" aria-label="Language" className={`inline-flex items-center ${className}`}>
      <button
        type="button"
        onClick={() => setLocale("tr")}
        aria-pressed={isTR}
        className={`px-2 py-1 transition-colors duration-300 ${isTR ? t.active : t.idle}`}
      >
        {copy.lang.tr}
      </button>
      <span className={t.sep}>/</span>
      <button
        type="button"
        onClick={() => setLocale("en")}
        aria-pressed={!isTR}
        className={`px-2 py-1 transition-colors duration-300 ${!isTR ? t.active : t.idle}`}
      >
        {copy.lang.en}
      </button>
    </div>
  );
}
